<template>
	<div id="multipleChoice">
		<div class="container">
			<div class="multipleleft">
				<div class="multipleSearch">
					<el-input style="flex: 1;" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="searchKey"
						@input="searchInput">
					</el-input>
					<!-- <div class="refresh" @click="toRefresh">
						刷新
					</div> -->
				</div>
				<div class="selectContainer" v-loading="loading">
					<div class="" v-if="searchList.length>0">
					<el-collapse v-model="activeNames" @change="handleChange">
						<el-collapse-item style="width: 100%;" :title="itm.catalog_name" :name="idx"
							v-for="(itm,idx) in searchList" :key="idx">
							<div class="selectContainer1">
								<div class="item" v-for="(item,index) in itm.majors" :key="index"
									:class="item.isSelect?'active':''" @click="selectItem(index,idx)">
									{{item.major_name}}
								</div>
							</div>
						</el-collapse-item>
					</el-collapse>
					</div>
					
					<el-empty v-else :image-size='150' description="暂无数据"></el-empty>
				</div>
			</div>
			<div class="multipleright">
				<div class="multipletop">
					<div class="selected">已选（{{rightList.length}}）</div>
					<div class="empty" @click="deleteAll">清空</div>
				</div>
				<div class="selectedContainer">
					<div class="selectedContainer1">
						<div class="item" v-for="(item,index) in rightList" :key="index"
							@click="deleteItem(index,item)">
							{{item.major_name}}
							<i class="el-icon-close"></i>
						</div>
					</div>
				</div>
			</div>

		</div>
		<div class="btnContainer">
			<el-button @click="cancel">取消</el-button>
			<el-button type="primary" @click="submit">确认</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'multipleChoice',
		props: {
			selectList: {
				type: Array,
				default: () => {
					return []
				},
			},
			multipleChange: {
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				searchKey: '',
				majorList: [], //专业列表
				loading: false,
				rightList: [],
				searchList: [],
				activeNames: [],
			}
		},
		watch: {
			multipleChange(val) {
				if (val) {
					this.rightList = []
					this.selectList.forEach((item) => {
						this.rightList.push({
							major_name: item,
							isSelect: false,
						})
					})
					this.searchList.forEach((item) => {
						item.majors.forEach((itm, idx, array) => {
							array[idx].isSelect = false
							this.selectList.forEach((i) => {
								if (itm.major_name == i) {
									array[idx].isSelect = true
								}

							})
						})
					})

				}
			},
			deep: true,
		},

		mounted() {
			this.getcatalogall()
			let arr = []
			for (let i = 0; i < 92; i++) {
				arr.push(i)
			}
			this.activeNames = arr
		},
		methods: {
			submit() {
				let submitArr = []
				this.submitArr = this.rightList.forEach((item) => {
					submitArr.push(item.major_name)
				})
				// this.rightList = [],
				this.$emit('submit', submitArr)


				setTimeout(() => {
					this.searchKey = ''
					this.searchInput()
				}, 1000)
			},
			cancel() {
				this.$emit('cancel')
			},
			handleChange(val) {
				
			},
			searchInput() {
				
				let searchList = JSON.parse(JSON.stringify(this.majorList))

				

				searchList.forEach((item, index, arr) => {
					arr[index].majors = item.majors.filter((itm) => {
						return (itm.major_name.toLowerCase()).indexOf(this.searchKey.toLowerCase()) != -1
					})
				})
				let searchList1 = []
				searchList1 = searchList.filter((item) => {
					return item.majors.length != 0
				})
				
				searchList.forEach((item) => {
					item.majors.forEach((itm, idx, array) => {
						this.rightList.forEach((i) => {
							if (itm.major_name == i.major_name) {
								array[idx].isSelect = true
							}
						})
					})
				})
				
				
				this.searchList = searchList1
			},
			deleteAll() {
				this.rightList = []
				this.searchList.forEach((item) => {
					item.majors.forEach((itm) => {
						itm.isSelect = false
					})
				})
			},
			deleteItem(index, im) {
				this.rightList.splice(index, 1)
				this.searchList.forEach((item) => {
					item.majors.forEach((itm, idx, array) => {
						if (itm.major_name == im.major_name) {
							array[idx].isSelect = false
						}
					})
				})

			},
			selectItem(index, idx) {
				// majors
				if (this.searchList[idx].majors[index].isSelect) {
					this.searchList[idx].majors[index].isSelect = false
					this.rightList = this.rightList.filter((item) => {
						return item.major_name != this.searchList[idx].majors[index].major_name
					})
				} else {
					this.searchList[idx].majors[index].isSelect = true
					this.rightList.push(this.searchList[idx].majors[index])
				}

			},
			toRefresh() {
				this.searchKey = []
				this.getcatalogall()
			},
			//获取专业列表
			getcatalogall() {
				this.loading = true
				this.$util.post(
					"v2/major/getcatalogall", {
						type_code: '0',
						user_id: 0,
					},
					(res) => {
						
						if (res.code == 0) {
							
							let array = res.data
							array.forEach((item) => {
								if (item.majors) {
									item.majors.forEach((itm, index, arr) => {
										arr[index].isSelect = false
									})

								}
							})
							
							// this.majorList = array
							// this.searchList = array
							
							this.searchList = JSON.parse(JSON.stringify(array))
							this.majorList = JSON.parse(JSON.stringify(array))
							
							
							this.loading = false
						}
					}
				);
			},


		},

	}
</script>
<style>
	#multipleChoice .el-collapse-item__header {
		font-size: 16px;
		font-weight: bold;
	}

	#multipleChoice .el-input__icon {
		line-height: 40px !important;
	}
</style>
<style lang="less" scoped>
	.container {
		border-top: 1px solid #eee;
		width: 100%;
		padding-top: 15px;

		display: flex;
		align-items: center;
		margin-bottom: 20px;
	}

	.multipleleft {
		width: 446px;
		height: 468px;
		border: 1px solid #eee;
		padding: 15px;
		margin-right: 20px;

		.multipleSearch {
			display: flex;
			align-items: center;

			.refresh {
				color: #1472ff;
				margin-left: 15px;
				cursor: pointer;
			}
		}

		.selectContainer {
			margin-top: 10px;
			width: 100%;
			height: 390px;
			overflow-y: scroll;

			.selectContainer1 {
				display: flex;
				flex-wrap: wrap;

				.item {
					margin: 0 8px 8px 0;
					border: 1px solid #dbdbdb;
					padding: 0 6px;
					// height: 22px;
					// line-height: 22px;
					cursor: pointer;
					border-radius: 2px;
					font-size: 12px;
				}

				.active {
					color: #1472ff;
					border: 1px solid #1472ff;
				}
			}

		}
	}

	.multipleright {
		border: 1px solid #eee;
		padding: 15px;
		flex: 1;
		height: 468px;
		padding: 15px;

		.multipletop {
			display: flex;
			align-items: center;
			height: 32px;

			.selected {
				flex: 1;
				font-size: 14px;
				font-weight: 500;
			}

			.empty {
				color: #1472ff;
				font-size: 14px;
				font-weight: 500;
				cursor: pointer;
			}
		}

		.selectedContainer {
			margin-top: 10px;
			width: 100%;
			height: 390px;
			overflow-y: scroll;

			.selectedContainer1 {
				display: flex;
				flex-wrap: wrap;

				.item {
					margin: 0 8px 8px 0;
					border: 1px solid #dbdbdb;
					padding: 0 6px;
					// height: 22px;
					// line-height: 22px;
					cursor: pointer;
					border-radius: 2px;
					font-size: 12px;
				}
			}

		}
	}

	.btnContainer {
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
</style>